/**
 * AAA IDP marketing consent reducer
 * Set the acceptance of marketing consent for the user
 * 
 */

import { ACCEPT_MARKETING_CONSENT, DELETE } from '../../actions/types';
const initialState = {
  error: false,
  required: false,
  valid: true,
  value: false
};
export default function (state = initialState, action) {
  switch (action.type) {
    case ACCEPT_MARKETING_CONSENT:
      {
        const {
          value
        } = action;
        return {
          error: false,
          required: false,
          valid: true,
          value
        };
      }
    case DELETE:
      return {
        error: false,
        required: false,
        valid: true,
        value: false
      };
    default:
      return state;
  }
}